"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DisabledContext = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var DisabledContext = _react.default.createContext(false);

exports.DisabledContext = DisabledContext;

var Disableable =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Disableable, _Component);

  function Disableable() {
    (0, _classCallCheck2.default)(this, Disableable);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Disableable).apply(this, arguments));
  }

  (0, _createClass2.default)(Disableable, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          toolbarTooltip = _this$props.toolbarTooltip;
      return _react.default.createElement(DisabledContext.Provider, {
        value: disabled
      }, _react.default.createElement(_UITooltip.default, {
        disabled: !disabled || !toolbarTooltip,
        placement: "bottom",
        title: toolbarTooltip
      }, this.props.children));
    }
  }]);
  return Disableable;
}(_react.Component);

Disableable.propTypes = {
  disabled: _react.PropTypes.bool,
  children: _react.PropTypes.node,
  toolbarTooltip: _react.PropTypes.string
};
Disableable.defaultProps = {
  disabled: false
};
var _default = Disableable;
exports.default = _default;